export default {
  SLOT_SET: 'SLOT_SET',
};
